var bannerContainers = document.querySelectorAll(".three-image-banner-container");

bannerContainers.forEach((container) => {

    if (container.dataset.activated == "true")
        return;

    container.dataset.activated = "true"
    const carousel = container.querySelector(".banner-items");

    // ============================================================
    // Set event listners for mobile scroll event and tracker items
    // ============================================================

    var mobileCarouselTrackers = container.querySelectorAll(".mobile-scroll-trackers .tracker-item");
    var mobileSlides = container.querySelectorAll(".banner-item");

    carousel.addEventListener("scroll", () => {
        for (let i = 0; i < mobileSlides.length; i++) {
            const element = mobileSlides[i];

            if (isElementInView(element)){
                container.querySelector(".mobile-scroll-trackers .tracker-item.active").classList.remove("active")
                mobileCarouselTrackers[i].classList.add("active");
                break
            }
        }
    });

    for (let i = 0; i < mobileCarouselTrackers.length; i++) {
        const tracker = mobileCarouselTrackers[i];
        
        tracker.addEventListener("click", () => {
            carousel.scrollLeft = mobileSlides[i].offsetLeft
            container.querySelector(".mobile-scroll-trackers .tracker-item.active").classList.remove("active")
            tracker.classList.add("active");
        });
    }
    
});

function isElementInView(element){
    var bounds = element.getBoundingClientRect()

    return (
        bounds.top >= 0
        && bounds.left >= 0
        && bounds.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        && bounds.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}